<template>
    <div id="myinfo-address">
      <f7-list form class="form-group">
        <f7-list-input
          input-id      ="address"
          name          ="address"
          type          ="textarea"
          resizable
          class         =""
          placeholder   =""
          :value        ="address"
          @input        = "setInputValue($event.target)"
          :label        ="$t('general-text-address')"
          autocomplete  ="off"
          v-show        ="isShow"
          outline
          floating-label
          required
          :disabled    = "isDisabled"
          :clear-button= "!isDisabled"
        ></f7-list-input>
    </f7-list>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      isShow:{
        type: Boolean
      },
      isDisabled:{
        type: Boolean
      },
    },
    mounted (){
      
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('myinfo', [
          'address'
      ])
    },
    methods: {
      ...mapActions('myinfo', [
        'setAddress',
        'validateInput'
      ]),

      setInputValue(inputEl){
        this.$emit("setInputValue", inputEl);
      },

      validateNextButton(){
        this.$emit("validateNextButton");
      }
    }
  }
</script>